import { render, staticRenderFns } from "./Ptz.vue?vue&type=template&id=126b1b9f&scoped=true&"
import script from "./Ptz.vue?vue&type=script&lang=js&"
export * from "./Ptz.vue?vue&type=script&lang=js&"
import style0 from "./Ptz.vue?vue&type=style&index=0&id=126b1b9f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126b1b9f",
  null
  
)

export default component.exports